const SantanderClabeStatus = {
  ASSIGNED: 'assigned',
  UNASSIGNED: 'unassigned'
};

export default SantanderClabeStatus;
